import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'

import { CardData, CardDataListing, CardDataPriority, isCardPriority } from '@/types/property-card'
import { MAX_SIMILAR_LISTINGS } from '@/utils/similars-helper'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleClick } from '@/utils/tracking/eventsHandlers'

import { CardPriorityWrapper } from '../CardPriority/CardPriorityWrapper'
import { ItemsCarousel } from '../ItemsCarousel'
import { linkBuilder } from '../Link/linkBuilder'
import { ListingCardVertical } from '../ListingCardVertical'

type Props = {
  similarListings: CardDataListing[]
  similarPriorities: CardDataPriority[]
}

export const SimilarPropertiesCarousel: React.FC<Props> = ({ similarListings, similarPriorities }) => {
  const { lang } = useTranslation()
  const cardCarouselWidth = 320

  const limitedNumberOfSimilarProperties: CardData[] = [...similarPriorities, ...similarListings].slice(
    0,
    MAX_SIMILAR_LISTINGS
  )

  return (
    <ItemsCarousel itemsGap="l" itemsWidth={cardCarouselWidth}>
      {limitedNumberOfSimilarProperties.map((item) => {
        if (isCardPriority(item)) {
          return (
            <CardPriorityWrapper
              key={item.id}
              cardData={item}
              data-testid="similar-card-priority"
              handleCardClick={() => handleClick(GTMEventCategory.SimilarPropertiesCarousel, 'Property', 'Priority')}
            />
          )
        }
        const link = linkBuilder.listingDetail.url(lang, item.id)
        return (
          <Link key={item.id} href={link}>
            <a>
              <ListingCardVertical
                favouriteEnabled
                cardData={item}
                data-testid="similar-card-listing"
                favoriteButtonGtmTouchpoint="SimilarCardOnMarket"
                onCardClick={() => handleClick(GTMEventCategory.SimilarPropertiesCarousel, 'Property', 'OnMarket')}
              />
            </a>
          </Link>
        )
      })}
    </ItemsCarousel>
  )
}
